import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RedeemWindowService } from '../services/redeem-window.service';

/** `/code` needs a live redeem window; otherwise go back to the start. */
export const activeRedeemWindowGuard: CanActivateFn = async () => {
  // inject() must run before the first await (no injection context afterwards).
  const router = inject(Router);
  const redeemWindow = inject(RedeemWindowService);
  await redeemWindow.ready;

  return redeemWindow.isExpired() ? router.createUrlTree(['/merchants']) : true;
};
